import * as Reach from '@reach/menu-button';
import styled from 'styled-components';
import { rgba } from 'polished';

import ChevronDownIcon from '#/assets/ChevronDownIcon';

import { cFFFFFF } from '#/colors';

import {
  useLocaleActions,
  useLocalesView,
} from '#/features/localization/localization-context';

import { NavItemPopoverButtonWithArrow, PopoverMenu } from './PopoverMenu';

export default function LocaleMenu() {
  const { locales, activeLocale } = useLocalesView();
  const actions = useLocaleActions();

  return (
    <Reach.Menu>
      <Reach.MenuButton as={NavItemPopoverButtonWithArrow} aria-label="Locale">
        {activeLocale.title} <ChevronDownIcon strokeWidth={2} />
      </Reach.MenuButton>

      <Reach.MenuList as={StyledPopoverMenu}>
        {locales.map((locale) => (
          <Reach.MenuItem
            key={locale.id}
            onSelect={() => actions.changeLocale(locale.id)}
            data-active={locale.id === activeLocale.id}
          >
            {locale.title}
          </Reach.MenuItem>
        ))}
      </Reach.MenuList>
    </Reach.Menu>
  );
}

const StyledPopoverMenu = styled(PopoverMenu)`
  [data-reach-menu-item] {
    color: ${rgba(cFFFFFF, 0.7)};
    font-size: 13px;
    font-weight: 500;
    padding: 8px 24px;
    cursor: pointer;

    &:hover {
      color: ${rgba(cFFFFFF, 0.85)};
    }

    &[data-active='true'] {
      color: ${cFFFFFF};
    }
  }
`;
